import { combineActions, handleActions } from 'redux-actions'

import {
  leaveContent,
  leaveContentFailed,
  leaveContentRequest,
  leaveContentSuccess,
} from '@tabeeb/shared/content/actions'

import { endCall, startCall } from '../actions/connection'
import { resetCallLeavingInProgress } from '../actions/conference'

export default handleActions<boolean, any>(
  {
    [leaveContent.toString()](state, { payload }) {
      return true
    },
    [combineActions(startCall, endCall).toString()](state, { payload }) {
      return false
    },
    [leaveContentRequest.toString()]() {
      return true
    },
    [combineActions(leaveContentFailed, leaveContentSuccess).toString()]() {
      return false
    },
    [resetCallLeavingInProgress.toString()]() {
      return false
    },
  },
  false
)
